export default __webpack_public_path__ + "static/media/treelineLg.8b53be6d.png";